import web3 from "web3";

export const shorter = (str, length = 6) => {
    try {
        return `${str.slice(0, length)}...${str.slice(str.length - 4, str.length)}`;
    } catch (err) {
        return '';
    }
};

export const truncate = (str, length = 100) => {
    return str.length > length ? str.substring(0, length) + "..." : str;
}

export const prettyNumber = (nb, string=true, isBig=true, unit='ether') => {
    let finalNumber = nb;

    try {
        if(isBig)
            finalNumber = web3.utils.fromWei(nb, unit);

        if(string)
            finalNumber = parseFloat(finalNumber).toLocaleString();
    } catch{
        finalNumber = "0"
    }

    return finalNumber

    // return parseInt(finalNumber) <= 0? (parseFloat(finalNumber).toFixed(4)).toLocaleString() : parseFloat(finalNumber).toLocaleString();
}
